module.exports = __webpack_public_path__ + "static/world-09e74774c98fd867bda040fa4f52bff9.jpg";